module.exports = __webpack_public_path__ + "static/media/moco.1a363800.jpg";